import fetch from 'cross-fetch';
import get from 'lodash/get';
import { actLoginTimedOut } from 'actions/loginStateActions';
import { actNotificationAdd } from 'actions/notificationActions';
import { getInspectionField } from 'store/selectors/inspectionJobWorkspace';
import { ApiPrefix, statusCheck, json, getCookie, nextPath } from 'util/icwUtility';
import {
  INSPECTION_JOB_INIT,
  INSPECTION_JOB_FETCH_BEGIN,
  INSPECTION_JOB_FETCH_SUCCESS,
  INSPECTION_JOB_FETCH_FAIL,
  INSPECTION_JOB_SUBMIT_BEGIN,
  INSPECTION_JOB_SUBMIT_SUCCESS,
  INSPECTION_JOB_SUBMIT_FAIL,
  INSPECTION_JOB_UPLOAD_BEGIN,
  INSPECTION_JOB_UPLOAD_SUCCESS,
  INSPECTION_JOB_UPDATE_BEGIN,
  INSPECTION_JOB_UPDATE_SUCCESS,
  INSPECTION_JOB_UPDATE_FAIL,
  INSPECTION_JOB_RESET,
  INSPECTION_JOB_GET_LAB_LIST,
} from './types';

export function actInspectionJobInit() {
  return { type: INSPECTION_JOB_INIT };
}

//  ******* Fetch Related *******

function actInspectionJobFetchBegin() {
  return { type: INSPECTION_JOB_FETCH_BEGIN };
}

function actInspectionJobFetchSuccess(data) {
  return { type: INSPECTION_JOB_FETCH_SUCCESS, data };
}

function actInspectionJobFetchFail(reason) {
  return { type: INSPECTION_JOB_FETCH_FAIL, reason };
}

export function actInspectionJobFetch(jobId) {
  return (dispatch) => {
    dispatch(actInspectionJobFetchBegin());
    return (
      fetch(`${ApiPrefix}/inspections/${jobId}`, {
        headers: { Authorization: getCookie('token') },
      })
        .then(statusCheck)
        .then(json)
        // eslint-disable-next-line no-shadow
        .then((json) => dispatch(actInspectionJobFetchSuccess(json)))
        .catch((err) => {
          if (err.status === 401) {
            dispatch(actLoginTimedOut());
          }

          dispatch(actInspectionJobFetchFail(typeof err === 'object' ? err.message : err));
        })
    );
  };
}

// ********** Inspection Form Submission Actions **************

function actInspectionJobSubmitBegin() {
  return { type: INSPECTION_JOB_SUBMIT_BEGIN };
}

export function actInspectionJobSubmitSuccess(inspectionId) {
  return { type: INSPECTION_JOB_SUBMIT_SUCCESS, inspectionId };
}

export function actInspectionJobUploadBegin() {
  return { type: INSPECTION_JOB_UPLOAD_BEGIN };
}

export function actInspectionJobUploadSuccess() {
  return { type: INSPECTION_JOB_UPLOAD_SUCCESS };
}

export function actInspectionJobSubmitFail(reason) {
  return { type: INSPECTION_JOB_SUBMIT_FAIL, reason };
}

export function actInspectionJobSubmit(data, history) {
  return (dispatch) => {
    dispatch(actInspectionJobSubmitBegin());

    return fetch(`${ApiPrefix}/inspections/create`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(statusCheck)
      .then(json)
      .then((inspectionId) => {
        dispatch(actInspectionJobSubmitSuccess(inspectionId));
        dispatch(actInspectionJobUploadBegin());
        // dispatch(actInspectionJobUploadSuccess());
        dispatch(
          actNotificationAdd({
            variant: 'success',
            message: 'inspection.jobCreateSuccess',
          })
        );
        nextPath(history)('/inspection');
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }
        dispatch(actInspectionJobSubmitFail(typeof err === 'object' ? err.message : err));
        dispatch(
          actNotificationAdd({
            variant: 'error',
            message: 'inspection.jobCreateFail',
            params: {},
          })
        );
      });
  };
}

//  ******* Job Update PUT ********

function actInspectionJobUpdateBegin() {
  return { type: INSPECTION_JOB_UPDATE_BEGIN };
}

export function actInspectionJobUpdateSuccess() {
  return { type: INSPECTION_JOB_UPDATE_SUCCESS };
}

export function actInspectionJobUpdateFail(reason) {
  return { type: INSPECTION_JOB_UPDATE_FAIL, reason };
}

export function actInspectionJobUpdate(type) {
  return (dispatch, getState) => {
    const state = getState().inspectionJobWorkspace.data;
    const jobId = state.id;
    const data = getInspectionField(getState(), type);

    dispatch(actInspectionJobUpdateBegin());
    return fetch(`${ApiPrefix}/inspections/${jobId}`, {
      method: 'PUT',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(statusCheck)
      .then(() => {
        dispatch(actInspectionJobUpdateSuccess());
        dispatch(
          actNotificationAdd({
            variant: 'success',
            message: 'inspection.jobUpdateSuccess',
          })
        );
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }
        dispatch(actInspectionJobUpdateFail(typeof err === 'object' ? err.message : err));
        dispatch(
          actNotificationAdd({
            variant: 'error',
            message: 'inspection.jobUpdateFail',
            params: {},
          })
        );
      });
  };
}

export function actInspectionJobReset() {
  return { type: INSPECTION_JOB_RESET };
}

//-------------------------------------------------
// GET_LAB_LIST
export function getLabListLoading() {
  return { type: INSPECTION_JOB_GET_LAB_LIST.LOADING };
}
export function getLabListSuccess(data) {
  return { type: INSPECTION_JOB_GET_LAB_LIST.SUCCESS, payload: data };
}
export function getLabListError(error) {
  return { type: INSPECTION_JOB_GET_LAB_LIST.ERROR, payload: error };
}
export function getLabList(cb) {
  return (dispatch) => {
    dispatch(getLabListLoading());
    const url = `${ApiPrefix}/serviceProviders/lists`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        type: 'inspection',
      }),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(getLabListSuccess(get(res, 'data', [])));
        if (cb) cb();
      })
      .catch((err) => {
        dispatch(getLabListError(typeof err === 'object' ? err.message : err));
      });
  };
}
